import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectedLang, getMenu } from "../../../../actions";

const Notifications = (props) => {
  useEffect(() => {
    getMenu();
  }, []);
  const {
    getMenus,
    commonContent,
    updatesAndNotifications,
    lofinMenu,
    location,
  } = props;

  const [notificationData, setNotificationData] = useState();
  useEffect(() => {
    if (updatesAndNotifications !== undefined) {
      setNotificationData(updatesAndNotifications);
    }
  }, [commonContent]);

  //notification
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
     
      function handleClickOutside(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(dropdownRef);


  const toggleDropDown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    return () => {
      document.removeEventListener("click", handleClickOut);
    };
  }, [isOpen]);
  //dropdown

  return (
      <div
        className="nav-item notificationcls align-self-center dropdown "
        ref={dropdownRef}
      >
        <a
          // className="nav-link"
          id="navbarDropdown1"
          onClick={toggleDropDown}
        >
          <img src="/images/New/NotificationIcon.svg" alt="notification icon" width={25} height={25} loading="lazy"/>
          
        </a>

        {isOpen && (
          <ul
            className="dropdown-body p-3"
            aria-labelledby="navbarDropdown1"
            style={{
              borderRadius: "15px",
              maxHeight: "310px",
              overflowY: "auto",
              left: "auto",
              right: "0px",
              border: "unset",
            }}
          >
            {notificationData &&
              notificationData.notifications &&
              notificationData.notifications.length > 0 &&
              notificationData.notifications.map((item, i) => (
                <>
                  {" "}
                  <li>
                    <a
                      href={
                        item.link.suggestedUrl && __CLIENT__
                          ? "/" + item.link.suggestedUrl
                          : item.link.uri
                      }
                      target="_blank"
                      className="dropdown-item text-wrap"
                    >
                      {item.description}
                      <p>{item.date}</p>
                    </a>
                  </li>
                  <li>
                    <hr class="dropdown-divider"></hr>
                  </li>
                </>
              ))}
          </ul>
        )}
        {/* <ul
          className="dropdown-menu dropdown-menu-end px-3"
          aria-labelledby="navbarDropdown1"
          style={{
            borderRadius: "15px",
            maxHeight: "310px",
            overflowY: "auto",
          }}
        >
          {notificationData &&
            notificationData.notifications &&
            notificationData.notifications.length > 0 &&
            notificationData.notifications.map((item, i) => (
              <>
                {" "}
                <li>
                  <a
                    href={
                      item.link.suggestedUrl && __CLIENT__
                        ? "/" + item.link.suggestedUrl
                        : item.link.uri
                    }
                    target="_blank"
                    className="dropdown-item text-wrap"
                  >
                    {item.description}
                    <p>{item.date}</p>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider"></hr>
                </li>
              </>
            ))}
        </ul> */}
      </div>
  );
};

const mapStateToProps = (state) => ({
  commonContent: state.commonContent,
  getMenus: state.commonContent.menu.headerMenu,
  updatesAndNotifications: state.commonContent.menu.updatesAndNotifications,
});

const mapDispatchToProps = (dispatch) => ({
  getMenu: bindActionCreators(getMenu, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
